import React, { useState, useEffect } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import 'react-datepicker/dist/react-datepicker.css';
import { teachersApi } from '../../../api/teachers/teachersApi';
import { Button, notification, Table, Card, List as ListAntd } from 'antd';
import { Link } from 'react-router-dom';
import { routesPath } from '../../../utils/routesPath';
import { convertRoutePathToLink, dateStringToYYYYMMDD } from '@/utils/functions';
import { useTranslation } from 'react-i18next'; // Added import
const { Meta } = Card;

const MySwal = withReactContent(Swal);
const URL = convertRoutePathToLink(routesPath.TEACHERS);

const DeleteOptions = ({ onChange, selectedTeacher }) => {
    const { t } = useTranslation(); // Added hook
    const [selected, setSelected] = useState(selectedTeacher);
    const [teachers, setTeachers] = useState([]);
    const [isLoadingTeachers, setIsLoadingTeachers] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 6,
        total: 0
    });
    const getListTeacher = () => {
        teachersApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize
            })
            .then((res) => {
                setIsLoadingTeachers(false);
                setTeachers(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };

    const internalOnChange = (item) => {
        setSelected(item);
        if (onChange) {
            onChange(item);
        }
    };

    useEffect(() => {
        getListTeacher();
    }, [pagination.page]);

    return (
        <div className="flex flex-col gap-2 justify-center items-center">
            <p>{t('Teacher_Admin_List_Delete_SelectReplacement')}</p>
            <ListAntd
                className="w-full"
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 6,
                    xxl: 2
                }}
                loading={isLoadingTeachers}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.page,
                    total: pagination.total,
                    onChange: (e) => setPagination({ ...pagination, page: e })
                }}
                dataSource={teachers}
                renderItem={(item) => {
                    return (
                        <ListAntd.Item>
                            <Card
                                className={`cursor-pointer ${
                                    selected?.id === item?.id ? 'border-1 border-red-500' : ''
                                }`}
                                title={item.title}
                                onClick={() => internalOnChange(item)}
                                cover={
                                    <div className="w-full !flex items-center justify-center p-2">
                                        <img
                                            className="w-[50%] rounded-xl"
                                            draggable={false}
                                            alt={t('Teacher_Admin_List_Delete_AvatarAlt')}
                                            src={
                                                item?.avatar
                                                    ? item?.avatar
                                                    : item?.gender == 'male'
                                                    ? '/assets/images/avatar_male.png'
                                                    : '/assets/images/avatar_female.png'
                                            }
                                        />
                                    </div>
                                }>
                                <Meta
                                    className="text-center"
                                    title={`${item?.firstName} ${item?.lastName}`}
                                />
                            </Card>
                        </ListAntd.Item>
                    );
                }}
            />
        </div>
    );
};

const ListComponent = ({ ...props }) => {
    const { t } = useTranslation(); // Added hook
    const [teachers, setTeachers] = useState([]);
    const [isLoadingTeachers, setIsLoadingTeachers] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });
    const getListTeacher = () => {
        teachersApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize
            })
            .then((res) => {
                setIsLoadingTeachers(false);
                setTeachers(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        getListTeacher();
    }, [pagination.page]);

    const handleDelete = (id) => {
        let assigneeTeacher = null;
        MySwal.fire({
            title: t('Teacher_Admin_List_Delete_Title'),
            text: t('Teacher_Admin_List_Delete_Text'),
            icon: 'warning',

            html: (
                <DeleteOptions
                    selectedTeacher={{ id }}
                    onChange={(assignee) => {
                        assigneeTeacher = assignee;
                    }}
                />
            ),

            preConfirm: () => {
                if (!assigneeTeacher) {
                    MySwal.showValidationMessage(t('Teacher_Admin_List_Delete_ValidationMessage'));
                    return false;
                }
                return assigneeTeacher;
            },

            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            confirmButtonText: t('Teacher_Admin_List_Delete_ConfirmButton'),
            cancelButtonText: t('Teacher_Admin_List_Delete_CancelButton'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                const replacementTeacher = result.value;
                teachersApi.delete(id, { teacherId: String(replacementTeacher?.id) }).then(() => {
                    notification.success({
                        message: t('Teacher_Admin_List_Delete_SuccessMessage')
                    });
                    getListTeacher();
                });
            }
        });
    };

    const columns = [
        {
            key: 'name',
            dataIndex: 'name',
            title: t('Teacher_Admin_List_Table_Name'),
            render: (_, record) => {
                return (
                    <>
                        {record?.firstName} {record?.lastName}
                    </>
                );
            }
        },
        { key: 'subject', dataIndex: 'subject', title: t('Teacher_Admin_List_Table_Subject') },
        { key: 'major', dataIndex: 'major', title: t('Teacher_Admin_List_Table_Major') },
        {
            key: 'experience',
            dataIndex: 'experience',
            title: t('Teacher_Admin_List_Table_Experience')
        },
        {
            key: 'onboardingDate',
            dataIndex: 'onboardingDate',
            title: t('Teacher_Admin_List_Table_OnboardingDate'),
            render: (_, record) => {
                return (
                    <>
                        {record?.onboardingDate
                            ? dateStringToYYYYMMDD(record?.onboardingDate)
                            : '-'}
                    </>
                );
            }
        },
        {
            key: 'action',
            dataIndex: 'action',
            title: '',
            render: (_, record) => {
                return (
                    <>
                        <Link to={URL + '/edit?id=' + record?.id}>
                            <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title={t('Teacher_Admin_List_EditButton')}>
                                <i className="fa fa-edit"></i>
                            </button>
                        </Link>
                        <button
                            onClick={() => handleDelete(record.id)}
                            type="button"
                            className="btn btn-icon btn-sm js-sweetalert"
                            title={t('Teacher_Admin_List_DeleteButton')}
                            data-type="confirm">
                            <i className="fa fa-trash-o text-danger"></i>
                        </button>
                    </>
                );
            }
        }
    ];

    return (
        <>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="header-action">
                            <h1 className="page-title">{t('Teacher_Admin_List_PageTitle')}</h1>
                            <ol className="breadcrumb page-breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="#">{t('Teacher_Admin_List_Breadcrumb_Brand')}</a>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    aria-current="page">
                                    {t('Teacher_Admin_List_Breadcrumb_Active')}
                                </li>
                            </ol>
                        </div>
                        <Link to={URL + '/edit'}>
                            <Button
                                className=" !bg-[#0d356b] !text-white hover:!bg-[#A40000] hover:!text-white hover:!border-[#A40000]"
                                size="large">
                                {t('Teacher_Admin_List_CreateButton')}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="section-body mt-4">
                <Table
                    loading={isLoadingTeachers}
                    columns={columns}
                    dataSource={teachers}
                    pagination={{
                        pageSize: pagination.pageSize,
                        current: pagination.page,
                        total: pagination.total,
                        onChange: (e) => setPagination({ ...pagination, page: e })
                    }}
                />
            </div>
        </>
    );
};

ListComponent.displayName = 'List';

const List = (props) => {
    return (
        <ErrorWrapper>
            <ListComponent
                data-id="List-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default List;
